import { useMemo } from "react";

import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";
import { getPaymentTypeOfSavedPaymentMethods } from "checkout-experience/utils/payment-helpers";
import { useCheckoutSession } from "checkout-query-client/hooks/use-checkout-session";

import { useEnabledPaymentMethods } from "./use-enabled-payment-methods";

export const useEnabledSavedPaymentMethods = () => {
  const {
    apiHost = "",
    version = "",
    checkoutSessionToken = "",
  } = useChexContext();

  const { data: checkoutSession } = useCheckoutSession({
    apiHost,
    version,
    checkoutSessionToken,
  });

  const { paymentMethods } = checkoutSession ?? {};
  const { paymentMethodsList } = useEnabledPaymentMethods();

  const allowedMOPs = useMemo(
    () => paymentMethodsList.map((method) => method.name),
    [paymentMethodsList]
  );

  return paymentMethods?.filter((summary) => {
    return allowedMOPs.includes(getPaymentTypeOfSavedPaymentMethods(summary));
  });
};
